import * as angular from 'angular';
import App from "./app/app";
import MenuTop from "./top/menu.top";
import TopBar from "./top-bar/top.bar";
import UserDropdown from "./user-dropdown/user.dropdown";
import UiToggleClass from "./ui-toggle-class/ui.toggle.class";
import Notifications from "./notifications/notifications.index";
import LeftSubBar from "./left-sub-bar/left.sub.bar";
import Avatar from "./avatar/avatar";
import { downgradeComponent } from '@angular/upgrade/static';
import { AvatarComponent } from 'ngx-avatar';

export default angular.module('CrazyWeb.Theme', [Notifications])
    .component("app", App)
    .component("menuTop", MenuTop)
    .component("topBar", TopBar)
    .component("userDropdown", UserDropdown)
    .component("avatar", Avatar)
    .component("leftSubBar", LeftSubBar)
    .directive('uiToggleClass', UiToggleClass)
    .directive('ngxAvatar', downgradeComponent({ component: AvatarComponent }))
  .name
